import View from './view.js';
import Events from '../util/eventEmitter';

namespace('IO.Views', function (exports) {
  var Sidebar = View.extend({
    dom: {
      FEATURE: '.feature',
    },

    initialize: function () {
      this._attachEvents();
    },

    update: function () {
      // NOTE: controller is a global var that is updated every request on .content
    },

    _attachEvents: function () {
      Events.on('enabledFeatures', this._updateFeatures.bind(this));
    },

    _updateFeatures: function (features) {
      this.$(this.dom.FEATURE).hide();

      _.each(
        features,
        function (item) {
          this.$('.' + item).show();
        },
        this,
      );
    },
  });

  exports.Sidebar = Sidebar;
});
